<template>
  <div>
  <myHeader></myHeader>

    <form class="form" method="post">
      <div class="webArticlesBloc">
        <h2>Actualités</h2>
        <div :key="index" v-for="(article, index) in article" class="webPublicationCardList">
          <div @click.prevent="editPublication(article._id)" type="submit">
            <div class="webPublicationCardListLine1">
              <p>{{ article.title }}</p>
              <p>{{ article.date }}</p>
            </div>
            <div class="webPublicationCardListLine2">
              <p>{{ article.description }}</p>
              <img class="webPublicationImages" v-bind:src=article.imageUrl>
            </div>
          </div>
        </div>
      </div>
  </form>

  <myFooter></myFooter>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
require('dotenv').config()
export default {
  name: 'PublicationsForWeb',
  data () {
    return {
      article: ''
    }
  },
  mounted () {
    this.getAllPublications()
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    getAllPublications () {
      axios
        .get(('https://privilegia.fr/api/articles'))
        .then((response) => {
          this.article = response.data.reverse()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SiteWeb/WebArticles.vue